import type { ReactNode } from "react"
import { useIsLoggedIn } from "@/hooks/reduxHooks"
import { Navigate, useLocation } from "react-router-dom"

type LoggedOutRouteProps = {
  children: ReactNode
}

const LoggedOutRoute = ({ children }: LoggedOutRouteProps) => {
  const loggedIn = useIsLoggedIn()

  const location = useLocation()
  const redirectLocation = { pathname: "/", state: { from: location } }

  if (!loggedIn) return <>{children}</>

  return <Navigate to={redirectLocation.pathname} state={redirectLocation.state} replace />
}

export default LoggedOutRoute
